export default __webpack_public_path__ + "media/images/home/slide_yakai_2026_sm-bd89cf7124762286b143b3eec546caf1.jpg";